import { provideAuth } from '@core/auth';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { BrowserUtils } from '@azure/msal-browser';
import {
  provideRouter,
  withComponentInputBinding,
  withDisabledInitialNavigation,
  withEnabledBlockingInitialNavigation,
} from '@angular/router';
import { routes } from '@/app.routes';
import { provideCache } from '@core/cache';
import { provideUserIdleConfig } from 'angular-user-idle';
import { SetupItemExternalIdInterceptor } from '@core/services';
import { NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateAdapter } from '@core/adapters/custom-date-adapter';
import { CustomDateParserFormatter } from '@core/adapters/custom-date-parser-formatter';
import { provideI18n } from '@core/i18n';
import { environment } from '@environments/environment';

const initialNavigation =
  !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
    ? withEnabledBlockingInitialNavigation() // Set to enabledBlocking to use Angular Universal
    : withDisabledInitialNavigation();

export function provideCore() {
  return [
    provideAnimationsAsync('animations'),
    provideI18n(),
    provideCache(),
    provideAuth(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes, initialNavigation, withComponentInputBinding()),
    provideUserIdleConfig({
      idle: environment?.idleTimeout?.idle || 1200, // Use environment config or fallback to 1200 seconds
      timeout: environment?.idleTimeout?.timeout || 60, // Use environment config or fallback to 60 seconds
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SetupItemExternalIdInterceptor,
      multi: true,
    },
    { provide: NgbDateAdapter, useClass: CustomDateAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ];
}
